export default __webpack_public_path__ + "static/media/pinkMarker.9a2264f6.svg";